import { render } from "./IdeaEvaluationOverviewVx.vue?vue&type=template&id=f63c3a6e&scoped=true"
import script from "./IdeaEvaluationOverviewVx.vue?vue&type=script&lang=js"
export * from "./IdeaEvaluationOverviewVx.vue?vue&type=script&lang=js"

import "./IdeaEvaluationOverviewVx.vue?vue&type=style&index=0&id=f63c3a6e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f63c3a6e"]])

export default __exports__